import { render } from "./DeveloperPortfolio.vue?vue&type=template&id=832e12da&scoped=true"
import script from "./DeveloperPortfolio.vue?vue&type=script&lang=js"
export * from "./DeveloperPortfolio.vue?vue&type=script&lang=js"

import "./DeveloperPortfolio.vue?vue&type=style&index=0&id=832e12da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-832e12da"]])

export default __exports__